module.exports = flarum.extensions['fof-components'];